// extracted by mini-css-extract-plugin
export default {"withIcon":"TimeInput_withIcon__-VhKR","clockIcon":"TimeInput_clockIcon__0iTPt"};